export default function StamopIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      style={{ marginTop: -3 }}
      aria-hidden="true"
      role="img"
      id="Regular"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 -960 960 960"
    >
      <path
        fill="currentColor"
        d="M145.087-65.869q-32.507 0-55.862-23.356-23.356-23.355-23.356-55.862v-469.826q0-32.74 23.356-56.262 23.355-23.521 55.862-23.521h230.782v-129.826q0-29.652 19.913-49.913 19.913-20.261 50.955-20.261h67.374q30.063 0 50.324 20.261t20.261 49.913v129.826h230.217q32.74 0 56.262 23.521 23.521 23.522 23.521 56.262v469.826q0 32.507-23.521 55.862-23.522 23.356-56.262 23.356H145.087Zm0-79.218h669.826v-469.826H583.566v30q-2.261 29.131-23.37 44.565-21.109 15.435-46.085 15.435h-67.657q-25.541 0-46.933-15.717-21.391-15.718-23.087-44.283v-30H145.087v469.826ZM232-241.913h239v-14q0-18-9-32t-23-19q-32-11-50-14.5t-35-3.5q-19 0-40.5 4.5t-48.5 13.5q-15 5-24 19t-9 32v14Zm336-67h170v-50H568v50Zm-214-50q22.5 0 38.25-15.75t15.75-38.25q0-22.5-15.75-38.25T354-466.913q-22.5 0-38.25 15.75T300-412.913q0 22.5 15.75 38.25t38.25 15.75Zm214-63h170v-50H568v50ZM451.13-600.174h58.305v-219.261H451.13v219.261ZM480-380Z"
      />
    </svg>
  );
}
